module.exports = __webpack_public_path__ + "img/mi3.5af886ba.png";